/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetOrganizationAgentsQueryVariables = Types.Exact<{
  orgId: Types.Scalars['uuid']['input'];
}>;

export type GetOrganizationAgentsQuery = {
  __typename?: 'query_root';
  grove_agents: Array<{
    __typename?: 'grove_agents';
    id: string;
    unique_id: string;
    name: string;
    description?: string | null;
    manifest?: any | null;
    instances: Array<{
      __typename?: 'agent_instances';
      id: string;
      enabled: boolean;
      enabled_at?: string | null;
      enabled_by_user?: {
        __typename?: 'users';
        id: string;
        email?: string | null;
        displayName: string;
      } | null;
    }>;
  }>;
};

export type SetOrganizationAgentsEnabledMutationVariables = Types.Exact<{
  objects: Array<Types.Agent_Instances_Insert_Input> | Types.Agent_Instances_Insert_Input;
}>;

export type SetOrganizationAgentsEnabledMutation = {
  __typename?: 'mutation_root';
  insert_agent_instances?: {
    __typename?: 'agent_instances_mutation_response';
    returning: Array<{ __typename?: 'agent_instances'; id: string; enabled: boolean }>;
  } | null;
};

export const GetOrganizationAgentsDocument = `
    query GetOrganizationAgents($orgId: uuid!) {
  grove_agents(
    where: {parent_id: {_is_null: false}, retired_at: {_is_null: true}}
    order_by: {name: asc}
  ) {
    id
    unique_id
    name
    description
    manifest
    instances(where: {organization_id: {_eq: $orgId}}) {
      id
      enabled
      enabled_at
      enabled_by_user {
        id
        email
        displayName
      }
    }
  }
}
    ` as string &
  TypedDocumentNode<GetOrganizationAgentsQuery, GetOrganizationAgentsQueryVariables>;
export const SetOrganizationAgentsEnabledDocument = `
    mutation SetOrganizationAgentsEnabled($objects: [agent_instances_insert_input!]!) {
  insert_agent_instances(
    objects: $objects
    on_conflict: {constraint: agent_instances_agent_id_organization_id_key, update_columns: [enabled, enabled_at, enabled_by]}
  ) {
    returning {
      id
      enabled
    }
  }
}
    ` as string &
  TypedDocumentNode<
    SetOrganizationAgentsEnabledMutation,
    SetOrganizationAgentsEnabledMutationVariables
  >;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetOrganizationAgents: build.query<
      GetOrganizationAgentsQuery,
      GetOrganizationAgentsQueryVariables
    >({
      query: (variables) => ({ document: GetOrganizationAgentsDocument, variables }),
    }),
    SetOrganizationAgentsEnabled: build.mutation<
      SetOrganizationAgentsEnabledMutation,
      SetOrganizationAgentsEnabledMutationVariables
    >({
      query: (variables) => ({ document: SetOrganizationAgentsEnabledDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useGetOrganizationAgentsQuery,
  useLazyGetOrganizationAgentsQuery,
  useSetOrganizationAgentsEnabledMutation,
} = injectedRtkApi;
